module.exports = __webpack_public_path__ + "static/media/R-Smart MotorAI.d02a7197.jpg";